import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {LineDetail} from "./line-detail";

const LineDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/lines');
    }

    return (
        <LineDetail id={id ? parseInt(id) : null} onClose={onClose}/>
    )

});

export default LineDetailPage;
